export enum ErrorMessageType {
  Storage,
  Filesystem,
  Connection,
  NotSynced,
  Microphone,
  RecordingInterrupted,
  Camera,
  DocumentScanner,
  ExecutionProofDraftOpen,
  Unknown
}
